import { useCallback, useState } from 'react';

import { AxiosError } from 'axios';

import { CamposLogin } from 'pages/Home/types';
import { Login } from 'models/login';
import { useGerenciadorDeMensagens } from 'hooks';
import { servicoBase } from 'services/servico-base';
import { UseLoginResposta } from './types';

export function useLogin(): UseLoginResposta {
  const criarMensagem = useGerenciadorDeMensagens();

  const [loading, setLoading] = useState<boolean>(false);
  const [erro, setErro] = useState<AxiosError | null>(null);

  const obterTextoDoErro = (responseData: any) => {
    if (!responseData || responseData.status === 400)
      return 'O provedor de autenticação está indisponível no momento. Tente novamente mais tarde.';
    return (
      responseData.detail ||
      'Erro ao efetuar o login. Tente novamente mais tarde.'
    );
  };

  const obterTituloDoErro = (responseData: any) => {
    if (!responseData || responseData.status === 400) return 'Ocorreu um erro';
    return 'Acesso negado!';
  };

  const login = useCallback(
    async (campos: CamposLogin) => {
      try {
        setLoading(true);

        const { data: result } = await servicoBase.post<Login | null>(
          '/v1/autenticacoes/login',
          campos,
        );

        return result || null;
      } catch (error: any) {
        criarMensagem({
          titulo: obterTituloDoErro(error?.response?.data),
          texto: obterTextoDoErro(error?.response?.data),
          tipo: 'erro',
        });
        setErro(error as AxiosError);
      } finally {
        setLoading(false);
      }

      return null;
    },
    [criarMensagem],
  );
  return [login, { loading, erro }];
}
